export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_08.44765472.gif";